export function TaxGroupsCtrl (
  $rootScope,
  $state,
  $scope,
  $translate,
  groups,
  messages,
  workshopAPI,
  xeroApi
) {

  $scope.groups       = groups;
  $scope.loaded       = true;
  $scope.xeroTaxRates = [];

  $scope.addGroup = function () {
    $scope.groups.push({
      name: '',
      tax_group_items_attributes: []
    });

    $scope.addType($scope.groups[ $scope.groups.length - 1 ]);
  };

  $scope.addType = function (group) {
    group.tax_group_items_attributes.push({
      tax_type: '',
      labor_gst_free: false,
      editing: true
    });
  };

  $scope.removeGroup = function (index) {
    if ($scope.groups[index].id) {
      workshopAPI.delete('/tax_group', $scope.groups[index].id).then(data => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.GROUP'), 'success');

        $state.reload();
      }).catch(err => {
        messages.error(err);
      });
    } else {
      $scope.groups.splice(index, 1);
    }
  };

  $scope.removeType = function (type) {
    workshopAPI.delete('/tax_group_item', type.id).then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.TAX_TYPE'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function (group) {
    const method = group.id ? 'patch': 'post';
    const url    = group.id ? '/tax_group': '/tax_groups';

    let isGroupValid = !!group.name;

    angular.forEach(group.tax_group_items_attributes, item => {
      isGroupValid = item.tax_type && item.tax_rate ? isGroupValid : false;
    });

    if (isGroupValid) {
      workshopAPI[method](url, group, 'tax_group').then(() => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.TAX_GROUP'), 'success');

        $state.reload();
      }).catch(err => {
        messages.error(err);
      });
    } else {
      messages.error('Invalid Input');
    }
  };

  $scope.toggleEditRow = function (type) {
    type.editing = !type.editing;
  };

  if ($rootScope.Company.hasIntegration('xero')) {
    xeroApi.getTaxRates()
    .then(rates => {
      $scope.xeroTaxRates = rates;
    });
  }
};